// extracted by mini-css-extract-plugin
module.exports = {"sessionBox":"SessionDetails_sessionBox__2eIwS"};